<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.29 12.91L3.08 8.7a3.53 3.53 0 01-1-1.8 3.4 3.4 0 011.1-3.27A3.52 3.52 0 018 3.92V4l.17-.18a3.5 3.5 0 014.83 0 3.42 3.42 0 01.94 3.06 3.59 3.59 0 01-1 1.86l-4.2 4.2a1 1 0 01-1.45-.03z"/></svg>